module.exports = __webpack_public_path__ + "img/pumpfun.c45523da.png";